export const getAuthStorage = () => {
  return JSON.parse(localStorage.getItem('auth') || '{}')
}
